export default "__VITE_ASSET__$_cvObI3__"